import React from "react"
import "./style.css"
import MainAreaSection from "../MainAreaSection"
import useLang from "../../hooks/useLang"

function ServicesMainArea({ title, img, description, pathForBanned }) {
  const currentPage = useLang() === "ar" ? "الخدمات" : "Services"
  const safePathBanned = pathForBanned || ""
  const finalPath = safePathBanned 
    ? `${currentPage}/${safePathBanned}` 
    : currentPage

  return (
    <MainAreaSection 
      img={img} 
      title={''} 
      currentPage={finalPath}
    >
      <div className="heading-text">
      </div>
    </MainAreaSection>
  )
}

export default ServicesMainArea
